<template>
  <Select
    :items="arrayRepresentantes"
    :selectedItem="filter.representante"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_representante')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        representante: {
          id: '',
          name: '',
        },
      },
      arrayRepresentantes: [],
    };
  },
  methods: {
    atualizar(representante) {
      this.filter.representante = representante;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.representante.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.representante.id
      });
    },
  },
  created() {
    this.arrayRepresentantes = this.filtro.parametros?.representantes || [];
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayRepresentantes, this.filter.representante);
  },
}
</script>
